import { FC } from "react";
import { NavLink, useNavigate } from "react-router-dom";

import Button from "../../../common/Button";

import IMAGES from "../../../../assets/themes/images/images";
import RoutingList from "../../../../utils/RoutingList";
import styles from "../login.module.scss";

const VerifySuccess: FC = (): JSX.Element => {
  const navigate = useNavigate();
  
  const navigateToChangePassword = () => {
    navigate(RoutingList.verify.changePasswordAfterVerify);
  };

  const navigateToLogin = () => {
    navigate(RoutingList.login.index);
  }

  return (
    <>
      <div className={`text-center ${styles.headerTop}`}>
        <div className={styles.imgBox}>
          <img src={IMAGES.EmailVerified} alt="email-verified" />
        </div>
        <h3 className="font-weight-semi-bold mb-1 heading3">
          Verification Successful.
        </h3>
        <p className="text-dark">
          Thank you for your support, we have successfully verified you.
        </p>
      </div>
      <div className={`${styles.loginFooterColumn}`}>
        <Button color="alert" type="button" onClick={navigateToChangePassword} className="mb-16">
          Change your password
        </Button>
        <NavLink
          to={RoutingList.login.index}
          type="button"
          onClick={navigateToLogin}
          className="btn btn-link text-decoration-none"
        >
          Skip
        </NavLink>
      </div>
    </>
  );
};

export default VerifySuccess;
